<script>
import { useElixioConnectStore } from '../../stores/elixioConnect'
import EcButton from '../ui/EcButton.vue'
import EcSpinner from '../ui/EcSpinner.vue'
import EcAlert from '../ui/EcAlert.vue'
import EcDrawer from '../ui/EcDrawer.vue'
import ShipmentList from './ShipmentList.vue'
import ShipmentForm from './ShipmentForm.vue'

export default {
  name: 'ShipmentManager',
  components: { EcButton, EcSpinner, EcAlert, EcDrawer, ShipmentList, ShipmentForm },
  props: {
    shippableType: { type: String, required: true },
    shippableId: { type: [String, Number], required: true },
  },
  data() {
    return {
      store: useElixioConnectStore(),
      loading: true,
      shipments: [],
      showFormDrawer: false,
    }
  },
  computed: {
    t() {
      return this.$ecTranslate || ((k) => k)
    },
  },
  mounted() {
    this.loadShipments()
  },
  methods: {
    async loadShipments() {
      this.loading = true
      try {
        const result = await this.store.fetchShipments(this.shippableType, this.shippableId)
        this.shipments = Array.isArray(result) ? result : (result?.data ?? [])
      } catch {
        this.shipments = []
      } finally {
        this.loading = false
      }
    },
    onFormSaved() {
      this.showFormDrawer = false
      this.loadShipments()
    },
    onListUpdated() {
      this.loadShipments()
    },
  },
}
</script>

<template>
  <div class="ec-shipment-manager">
    <!-- Header -->
    <div class="ec-flex ec-justify-between ec-items-center ec-mb-3">
      <h5 style="margin: 0">{{ t('ELIXIO_CONNECT.SHIPMENTS') }}</h5>
      <EcButton variant="primary" size="sm" icon="plus-lg" @click="showFormDrawer = true">
        {{ t('ELIXIO_CONNECT.NEW_SHIPMENT') }}
      </EcButton>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="ec-text-center" style="padding: 2rem 0">
      <EcSpinner />
    </div>

    <!-- Empty state -->
    <EcAlert v-else-if="!shipments.length" type="info">
      {{ t('ELIXIO_CONNECT.NO_SHIPMENTS') }}
    </EcAlert>

    <!-- Shipment list -->
    <ShipmentList
      v-else
      :shipments="shipments"
      @updated="onListUpdated"
    />

    <!-- Form drawer -->
    <EcDrawer
      v-model="showFormDrawer"
      :title="t('ELIXIO_CONNECT.NEW_SHIPMENT')"
      width="1000px"
      resizable
    >
      <ShipmentForm
        :shippable-type="shippableType"
        :shippable-id="shippableId"
        @saved="onFormSaved"
        @cancel="showFormDrawer = false"
      />
    </EcDrawer>
  </div>
</template>
